import { useUserOrganization } from "@/utils/partnerData";
import Logo from "@img/Logo";
import { Col, Divider, Flex, Layout, Row } from "antd";
import { Link } from "react-router";
import "./Footer.css";

const currentYear = new Date().getFullYear();

const footerData = [
    {
        key: "about",
        to: "about",
        title: "About Us",
    },
    {
        key: "search",
        to: "results",
        title: "Search Clinical Trials",
    },
    {
        key: "learnMore",
        to: "overview",
        title: "Learn More",
    },
    {
        key: "glossary",
        to: "glossary",
        title: "Glossary",
    },
    {
        key: "faq",
        to: "faq",
        title: "FAQ",
    },
    {
        key: "contact",
        to: "contact_us",
        title: "Contact Us",
    },
    {
        key: "privacy",
        to: "privacy_policy",
        title: "Privacy Policy",
    },
    {
        key: "terms",
        to: "terms_of_use",
        title: "Terms of Use",
    },
];

function PartnerFooter() {
    return (
        <Layout.Footer className="footer">
            <Flex justify="space-between" align="center" wrap="wrap" gap="large">
                <a
                    className="footer-item font-size-xs font-weight-normal"
                    href="https://isimchahealth.com"
                    target="_blank"
                    rel="noreferrer"
                >
                    © {currentYear} iSimcha LLC
                </a>
                <Flex>
                    <Link className="footer-item" to="/privacy_policy">
                        Privacy Policy
                    </Link>
                    <Link className="footer-item" to="/terms_of_use">
                        Terms of Use
                    </Link>
                </Flex>
            </Flex>
        </Layout.Footer>
    );
}

function Footer() {
    // anchor tag is required to navigate directly to the privacy policy
    return (
        <Layout.Footer className="footer pt-5">
            <Row gutter={[16, 24]} className="pb-4">
                <Col xs={24} sm={24} md={6}>
                    <Logo white trademarked width="120" height="60" fill="#fff" />
                </Col>
                <Col xs={24} sm={24} md={18}>
                    <Flex component="nav" wrap="wrap" gap="small" justify="start">
                        {footerData.map((item) => (
                            <Link className="footer-item" title={item.title} key={item.key} to={item.to}>
                                {item.title}
                            </Link>
                        ))}
                    </Flex>
                </Col>
            </Row>
            <Divider className="footer-divider" plain />
            <div className="footer-bottom">
                <a
                    className="footer-item font-size-xs font-weight-normal"
                    href="https://isimchahealth.com"
                    target="_blank"
                    rel="noreferrer"
                >
                    © {currentYear} iSimcha LLC
                </a>
            </div>
        </Layout.Footer>
    );
}

function FooterWrapper() {
    const { userOrganization } = useUserOrganization();

    if (!userOrganization.isDefault) {
        return <PartnerFooter />;
    }
    return <Footer />;
}
export default FooterWrapper;
